import { DeleteAction } from './actions/deleteAction'
import { MoveAction } from './actions/moveAction'
import { deleteDirectoryItem, fetchItemsForDirectory, updateDirectoryItem } from './files.service'
import { useFileManager } from './useFileManager'

export const useFileManagerConnected = (directoryId?: string) =>
  useFileManager({
    directoryId,
    nodeFetcher: (options) => fetchItemsForDirectory(options),
    actionEvents: {
      delete: async (action: DeleteAction) => {
        await Promise.all(action.items.map((item) => deleteDirectoryItem(item)))
      },
      move: async (action: MoveAction) => {
        await Promise.all(
          action.items.map((item) =>
            updateDirectoryItem(item, {
              type: item.type,
              directoryId:
                action.targetDirId !== 'root'
                  ? action.targetDirId
                  : '00000000-0000-0000-0000-000000000000'
            })
          )
        )
      },
      edit: (action) => {
        return updateDirectoryItem(action.item, action.edits)
      }
    }
  })
